<template>
<div ref="world" class="World" :class="{ 'is-blur': blur, 'is-hidden': slugIsIn(['introduction']) }">
  <Scene/>
  <template v-if="loaded">
    <Environment/>
    <Fog v-if="slugIsBefore('merci') && $route.meta.name == 'museum'"/>
    <Camera/>
    <Localisator/>
    <Physics/>
    <Blur/>
    <PointerLock v-if="!$root.$agent.mobile"/>
    <CursorComp v-if="slugIsAfter('instructions') || $route.meta.name == 'artwork'"/>
    <Oeuvres/> 
    <UpSideDown v-if="slugIsAfter('33') || $route.meta.name == 'artwork'"/>

    <ControlsComp v-if="($root.$agent.mobile && !is2DWorld && slugIsAfter('instructions')) || ($route.meta.name == 'artwork' && !$route.params.id && $root.$agent.mobile)"/>

    <RequestPermission 
      v-if="($root.$agent.mobile && !is2DWorld && slugIsAfter('instructions') && request_needed) 
         || ($route.meta.name == 'artwork' && !$route.params.id && $root.$agent.mobile && request_needed)"/>

  </template>
</div>
</template>

<script>
import Environment from './elements/Environment'
import Scene from './elements/Scene'
import Camera from './elements/Camera'
import Physics from './elements/Physics'
import Oeuvres from './elements/Oeuvres'
import Localisator from './elements/Localisator'
import Fog from './elements/Fog'
import UpSideDown from './elements/UpSideDown'
import CursorComp from './elements/Cursor'
import Blur from './elements/Blur'
import PointerLock from './elements/PointerLock'
import ControlsComp from '@/components/controls/ControlsComp'
import RequestPermission from '@/components/controls/RequestPermission'

export default {
  name: 'World',
  data: () => ({
    blur: false,
    used: false,
  }),
  components: {
    Scene,
    Environment,
    Camera,
    Physics,
    Oeuvres,
    Localisator,
    Fog,
    UpSideDown,
    CursorComp,
    Blur,
    PointerLock,
    ControlsComp,
    RequestPermission
  },
  computed: {
    loaded() { return this.$store.getters['loader/loaded'] },
    request_needed() { return this.$store.getters['app/request_needed'] },
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        if(this.slugIsBefore('monde')) 
          this.used = false
        if(this.slugIsIn(['monde', 'monde:1', 'monde:2'])) {
          if(!this.used) {
            this.used = true
            TweenMax.from(this.$el, 1, { opacity: 0, delay : 2 })
          }
        }
      }
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.World
  top 0px
  left 0px
  height 100vh
  width 100vw
  overflow hidden
  position absolute
  transition 1s filter linear
  &.is-hidden
    opacity 0
  &.is-blur
    filter blur(10px)
    transform translateZ(0)
    will-change transform
</style>



// WEBPACK FOOTER //
// src/components/world/World.vue